import { useEffect, useState } from 'react';
import { applyServiceWorkerUpdate } from '../../serviceWorkerRegistration';

// index.js dispara 'fg-sw-update' con la registration cuando hay un SW
// nuevo instalado y esperando. Actualizar solo reemplaza los assets (JS/CSS/
// SW) vía reload controlado — IndexedDB/localStorage no se tocan, así que
// las aplicaciones pendientes de sincronizar no se pierden.
function UpdateAvailableBanner() {
  const [registration, setRegistration] = useState(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    function handleUpdate(event) {
      setRegistration(event.detail);
    }
    window.addEventListener('fg-sw-update', handleUpdate);
    return () => window.removeEventListener('fg-sw-update', handleUpdate);
  }, []);

  if (!registration) return null;

  const handleActualizar = () => {
    setUpdating(true);
    applyServiceWorkerUpdate(registration);
  };

  return (
    <div className="fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-[calc(env(safe-area-inset-top)+12px)]">
      <div className="flex w-full max-w-sm items-center gap-3 rounded-xl bg-gray-900 px-4 py-3 text-white shadow-lg">
        <p className="flex-1 text-sm">Nueva versión disponible</p>
        <button
          type="button"
          onClick={handleActualizar}
          disabled={updating}
          className="shrink-0 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 transition-colors hover:bg-gray-100 disabled:opacity-60"
        >
          {updating ? 'Actualizando...' : 'Actualizar'}
        </button>
      </div>
    </div>
  );
}

export default UpdateAvailableBanner;
